const isApplePlatform = () => (/Mac|iPhone|iPad/).test(window.navigator.userAgent);

export const getModifierKey = () => {
  if (isApplePlatform()) {
    return '⌘';
  }
  return 'Ctrl';
};

export type KeyboardHint = { keys: string[]; label: string };

export const getKeyboardHints = (): KeyboardHint[] => [
  { keys: [getModifierKey(), 'K'], label: 'Search anywhere' },
  { keys: ['/'], label: 'Open search' },
  { keys: ['↑', '↓'], label: 'Move through results' },
  { keys: ['↵'], label: 'Open result' },
  { keys: ['esc'], label: 'Close' },
];

export const SIDEBAR_HINT_COUNT = 3;
